// test1887
(1887 && 0);
